import { RouteType } from '../../../types';
import { VanityDuplicateCompensationScreen } from './screens';

const routes: RouteType[] = [
  {
    path: '/sp3/game-config/vanity-duplicate-compensation',
    name: 'Vanity Duplicate Compensation',
    component: VanityDuplicateCompensationScreen,
  },
];

export default routes;
